export const SET_LIST_SUB_JOB = "SET_LIST_SUB_JOB";
export const ADD_NEW_JOB = "ADD_NEW_JOB";
export const ADD_JOB_IMAGE = "ADD_JOB_IMAGE";